import { useEffect } from "react";
import * as THREE from "three";

/**
 * Disposes every mesh material in the cloned GLB scene on unmount or scene
 * change, freeing GPU memory Three.js won't reclaim automatically.
 */
export const useDisposeSceneMaterials = (scene: THREE.Object3D): void => {
  useEffect(
    () => () => {
      scene.traverse((object) => {
        if (!(object instanceof THREE.Mesh)) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Three's Mesh.material is `any` in its type defs
        const material = object.material;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- same: Three.js typing gap
        if (Array.isArray(material)) for (const mat of material) mat.dispose();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- same
        else material.dispose();
      });
    },
    [scene],
  );
};
